import { IconCheck } from "@tabler/icons-react";
import type { FC } from "react";
import {
  composeRenderProps,
  ListBoxItem,
  type ListBoxItemProps,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { menuStyle } from "../Menu/menuStyle.js";

export interface ComboboxItemProps extends Omit<
  ListBoxItemProps,
  "className" | "style"
> {
  className?: string;
}

/** A selectable option inside {@link ComboboxContent}, with a checkmark when selected. */
export const ComboboxItem: FC<ComboboxItemProps> = (props) => {
  const { className, children, ...itemProps } = props;

  return (
    <ListBoxItem
      // Filtering and type-to-select match on textValue, which react-aria can
      // no longer infer once we wrap children in extra markup below.
      textValue={typeof children === "string" ? children : undefined}
      {...itemProps}
      className={twMerge(
        menuStyle().item(),
        "min-w-0 justify-start",
        className,
      )}
    >
      {composeRenderProps(children, (children) => (
        <>
          <span className="flex-1 truncate">{children}</span>
          <IconCheck
            className={menuStyle().itemIcon({
              className: "invisible text-indigo-600 group-selected:visible",
            })}
          />
        </>
      ))}
    </ListBoxItem>
  );
};
